export default {
  icon: 'mdi-account',
  icons: {
    chevron_down: 'mdi-chevron-down',
    chevron_up: 'mdi-chevron-up',
  },
  name: 'Consigne',
  title: 'Consignes',
  noItems:
    "Il n'y a pas encore de consigne en relation avec l'organisation et les filtres sélectionnés",
  description: 'Description',
  fields: {
    dispatcher: '',
    start_datetime: '',
    end_datetime: '',
    contract_id: '',
    property_code: '',
    message: '',
    actions: '',
  },
};
